import { getItemMaker } from "./tools";

const food = getItemMaker("health food");
export const healthFood = [
  food("Nomwich", "FoodHealth1"),
  food("Hot Dog", "FoodHealth3"),
  food("Cheezy Pizza", "FoodHealth2"),
  food("Peanut", "Peanut"),
  food("Saucy Weiner", "FoodHealth4"),
  food("Kebab Sticks", "FoodHealth6"),
  food("Meat Pie", "FoodHealth7"),
  food("Mountain Bread", "FoodHealth10"),
  food("Yeti Ham", "FoodHealth9"),
  food("Sheepie Dairy", "FoodHealth11"),
  food("Cupcake", "FoodHealth13"),
  food("Spicy Space Ribs", "FoodHealth12"),
  food("Lemon Slice"),
  food("Grilled Cheese Nomwich", "FoodHealth15"),
  food("Raw Nigiri"),
  food("Dumpling"),
  food("Cranberry Jam", "FoodHealth5"),
  food("Milk Choco", "FoodEvent8"),
  food("Magic Meatloaf", "Meatloaf"),
];

const boost = getItemMaker("boost food");
export const boostFood = [
  boost("Small Strength Potion", "FoodPotOr1"),
  boost("Average Strength Potion", "FoodPotOr2"),
  boost("Decent Strength Potion", "FoodPotOr3"),
  boost("Potent Strength Potion", "FoodPotOr4"),
  boost("Small Life Potion", "FoodPotRe1"),
  boost("Average Life Potion", "FoodPotRe2"),
  boost("Decent Life Potion", "FoodPotRe3"),
  boost("Potent Life Potion", "FoodPotRe4"),
  boost("Small Speed Potion", "FoodPotGr1"),
  boost("Average Speed Potion", "FoodPotGr2"),
  boost("Decent Speed Potion", "FoodPotGr3"),
  boost("Potent Speed Potion", "FoodPotGr4"),
  boost("Small Mana Potion", "FoodPotMana1"),
  boost("Average Mana Potion", "FoodPotMana2"),
  boost("Decent Mana Potion", "FoodPotMana3"),
  boost("Potent Mana Potion", "FoodPotMana4"),
  boost("Small EXP Potion", "FoodPotYe1"),
  boost("Average EXP Potion", "FoodPotYe2"),
  boost("Minto Choco", "FoodEvent7"),
  boost("Decent EXP Potion", "FoodPotYe3"),
  boost("Potent EXP Potion", "FoodPotYe4"),
  boost("Quotient EXP Potion", "FoodPotYe5"),
  boost("Lemony Choco", "FoodEvent6"),
  boost("Shiny Pearl"),
  boost("Icing Ironbite", "FoodMining1"),
  boost("Giftybread Man", "FoodEvent1"),
  boost("Stained Pearl", "Pearl2"),
  boost("Saucy Logfries", "FoodChoppin1"),
  boost("Chogg Nog", "FoodEvent2"),
  boost("Slurpin Herm", "FoodFish1"),
  boost("Candy Canes", "FoodEvent3"),
  boost("Aqua Pearl", "Pearl1"),
  boost("Buttered Toasted Butter", "FoodCatch1"),
  boost("Mistleberries", "FoodEvent4"),
  boost("Critter Numnums"),
  boost("Soulble Gum"),
  boost("Bullet", "Bullet"),
  boost("FMJ Bullet"),
  boost("Coldseeker Bullet", "Bullet3"),
  boost("Midnight Cookie", "MidnightCookie"),
  boost("Cherry Choco", "FoodEvent5"),
];

const golden = getItemMaker("golden food");
export const goldenFood = [
  golden("Golden Peanut"),
  golden("Golden Jam", "FoodG1"),
  golden("Golden Kebabs", "FoodG2"),
  golden("Golden Meat Pie", "FoodG3"),
  golden("Golden Nomwich", "FoodG4"),
  golden("Golden Ham", "FoodG5"),
  golden("Golden Bread", "FoodG6"),
  golden("Golden Ribs", "FoodG7"),
  golden("Golden Cheese", "FoodG8"),
  golden("Golden Grilled Cheese Nomwich", "FoodG9"),
  golden("Golden Hampter Gummy Candy", "FoodG10"),
  golden("Golden Nigiri", "FoodG11"),
  golden("Golden Dumpling", "FoodG12"),
  golden("Golden Cake", "FoodG13"),
  golden("Butter Bar", "ButterBar"),
];
